<!--  -->
<template>
  <div class="clientview">
    <div class="tabselecr_box">
      <div class="selcet_box search_box">
        <!-- <el-input v-model="query.area" clearable style="width:400px;margin-right:10px" placeholder="请输入区域" /> -->
        <el-select v-model="query.area" style="width: 300px;" placeholder="请选择区域">
          <el-option
            v-for="item in areaarr"
            :key="item.value"
            :label="item.area"
            :value="item.value"
          />
        </el-select>
        <el-select v-model="query.up_plus" style="width: 300px;" placeholder="是否由创+">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-input v-model="query.ip" placeholder="请输入ip" style="width: 300px;" />
        <el-input v-model="query.client_host" placeholder="请输入设备编号" style="width: 300px;" />
        <el-button type="primary" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
        <!-- <div style="width: 250px;">
          <span style="margin:0 10px">总绑定数:</span>
          <span>{{ allBindCount }}</span>
        </div> -->
        <el-tag type="success" style="margin-left:10px">总绑定数：{{ allBindCount }}</el-tag>
        <el-tag color="#a27de7" back style="margin-left:10px; color: #fff; border-color:#a27de7;">已登录数：{{ allLoginCount }}</el-tag>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="add(1)">新增</el-button>
        <el-button type="primary" icon="el-icon-download" @click="exporwqwe">导出</el-button>
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="area_str"
        label="区域"
        align="center"
        width="130"
      />
      <el-table-column
        prop="ip"
        label="外网IP"
        align="center"
      />
      <el-table-column
        prop="internal_ip"
        label="内网IP"
        align="center"
      />
      <el-table-column
        prop="client_host"
        label="客户端地址"
        align="center"
      />
      <el-table-column
        prop="up_plus"
        label="是否由创+"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.up_plus == 1 ? '否' : '是' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="version"
        label="版本"
        align="center"
      />
      <el-table-column
        prop="max_bind"
        label="绑定上限"
        align="center"
        width="100"
      />
      <el-table-column
        prop="set_max_bind"
        label="最大上限"
        align="center"
        width="100"
      />
      <el-table-column
        prop="bind_count"
        label="已绑定个数"
        align="center"
        width="100"
      />
      <el-table-column
        prop="bind_remain"
        label="剩余绑定数量"
        align="center"
        width="100"
      />
      <el-table-column
        prop="client_host"
        label="操作"
        align="center"
        width="500"
        fixed="right"
      >
        <template slot-scope="scope">
          <div>
            <el-button type="warning" size="mini" @click="add(2,scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="deteleter(scope.row.id)">删除</el-button>
            <el-button type="success" size="mini" @click="lookbinding(scope.row.client_host)">查看绑定</el-button>
            <el-button type="primary" size="mini" @click="bindProxy(scope.row)">绑定代理</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <!-- 预览标签组弹窗 -->
    <el-dialog
      title="新增客户端"
      :visible.sync="clientdiavieser"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
    >
      <clientdialog ref="clientdialogview" @updata="updata" />
    </el-dialog>
    <!-- 预览标签组弹窗 -->
    <el-dialog
      title="查看绑定"
      :visible.sync="banddialogdialig"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <banddialog ref="banddialogview" @closer="closer" />
    </el-dialog>
    <el-dialog
      title="绑定代理"
      :visible.sync="bind_proxy_dialog"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <div class="clientview">
        <div class="tabselecr_box">
          <div class="selcet_box">
            <el-input
              v-model="proxy_query.address"
              placeholder="请输入地址"
              style="margin-right:10px;"
              @keyup.enter.native="searchLickProxy"
            />
            <el-button type="primary" icon="el-icon-search" @click="searchLickProxy">搜索</el-button>
          </div>
        </div>

        <el-table
          v-loading="loading"
          :data="proxyData"
          border
          style="width: 100%"
        >
          <el-table-column prop="account" label="账户" width="200" align="center" />
          <el-table-column prop="port" label="端口" width="200" align="center" />
          <el-table-column prop="pwd" label="密码" width="250" align="center" />
          <el-table-column prop="address" label="IP地址" min-width="300" align="center" />
          <el-table-column prop="bind_count" label="绑定个数" width="200" align="center" />
          <el-table-column prop="client_host" label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="warning" size="mini" @click="bind(scope.row)">绑定</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination-right
          :current-page="query.page"
          :total="total"
          @size-change="proxyFetchPageSize"
          @current-change="proxyFetchCurrentPage"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { clientindex, clientdestroy, clientareaList, proxyConfigList, bindProxy, clientexport } from '@/api/officialaccount.js'
import clientdialog from './components/clientdialog.vue'
import banddialog from './components/banddialog.vue'
export default {
  name: 'Clientlist',
  components: { PaginationRight, clientdialog, banddialog },
  data() {
    return {
      query: {
        page: 1,
        page_size: 10,
        area: '',
        ip: '',
        client_host: '',
        up_plus: ''
      },
      tableData: [],
      total: null,
      loading: false,
      clientdiavieser: false,
      areaarr: [],
      banddialogdialig: false,
      allBindCount: null,
      allLoginCount: null,
      options: [{
        value: 1,
        label: '否'
      }, {
        value: 2,
        label: '是'
      }],
      bind_proxy_dialog: false,
      instance_id: null,
      proxyData: [],
      proxy_query: {
        page: 1,
        page_size: 10,
        address: ''
      }
    }
  },
  created() {
    this.list()
    this.arealist()
  },
  mounted() {

  },
  activated() {
    // this.list()
  },
  methods: {
    async list() {
      this.loading = true
      const data = await clientindex(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      this.allBindCount = data.data.allBindCount
      this.allLoginCount = data.data.login_count
      this.loading = false
      console.log('data', data)
    },
    async arealist() {
      const data = await clientareaList()
      this.areaarr = data.data
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.area = ''
      this.query.ip = ''
      this.query.client_host = ''
      this.query.up_plus = ''
      this.list()
    },
    add(type, item) {
      this.clientdiavieser = true
      if (type === 1) {
        this.$nextTick(() => {
          this.$refs.clientdialogview.send(type)
        })
      } else {
        this.$nextTick(() => {
          this.$refs.clientdialogview.send(type, item)
        })
      }
    },
    updata() {
      this.clientdiavieser = false
      this.list()
    },
    deteleter(id) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        clientdestroy({
          id: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.list()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
      // customerMessagedelete
    },
    lookbinding(client_host) {
      this.banddialogdialig = true
      this.$nextTick(() => {
        this.$refs.banddialogview.send(client_host)
      })
      console.log(client_host)
    },
    closer() {
      this.banddialogdialig = false
    },
    proxyFetchPageSize(e) {
      this.proxy_query.pageSize = e
      this.proxyList()
    },
    proxyFetchCurrentPage(e) {
      this.proxy_query.page = e
      this.proxyList()
    },
    async proxyList() {
      try {
        const data = await proxyConfigList(this.proxy_query)
        this.proxyData = data?.data?.list || []
        this.total = data?.data?.total || 0
      } catch (e) {
        this.$message.error('列表获取失败')
      }
    },
    bindProxy(val) {
      this.instance_id = val.id
      this.proxy_query = {
        page: 1,
        page_size: 10,
        address: ''
      }
      this.proxyList()
      this.$nextTick(() => {
        this.bind_proxy_dialog = true
      })
    },
    searchLickProxy() {
      this.proxy_query.page = 1
      this.proxyList()
    },
    bind(val) {
      console.log(this.instance_id)
      console.log(val)
      if (this.instance_id) {
        bindProxy({ instance_id: this.instance_id, proxy_config_id: val.id }).then(res => {
          console.log(res)
          if (res.code === 200) {
            this.$message.success('绑定成功')
            this.bind_proxy_dialog = false
          }
        })
      }
    },
    exporwqwe() {
      this.$confirm('确认是否导出？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用导出接口，使用当前查询条件
        clientexport(this.query).then(res => {
          const downloadUrl = res.data?.url
          if (downloadUrl) {
            // 在新窗口打开下载链接
            window.open(downloadUrl, '_blank')
            this.$message({
              type: 'success',
              message: '导出成功'
            })
          } else {
            this.$message({
              type: 'error',
              message: '导出失败：未获取到下载地址'
            })
          }
        }).catch(err => {
          this.$message({
            type: 'error',
            message: err.message || '导出失败'
          })
        })
      }).catch(() => {
        // 用户取消，不做任何操作
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.clientview{
  padding: 30px;
}
.tabselecr_box{
  margin-bottom: 20px;
}
.tabselecr_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.selcet_box{
  display: flex;
  align-items: center;
  /* align-items:flex-end */
}
.btn-box{
    display:flex;
    gap:1vw;
    flex-direction: column;
  }
  .btn-box button{
    margin:0px;
  }
@media (max-width: 768px){
  .btn-box{
    display:flex;
    gap:1vw;
  }
}
</style>
